/* unplugin-vue-components disabled */import { render } from "./Record.vue?vue&type=template&id=23170551"
import script from "./Record.vue?vue&type=script&lang=js"
export * from "./Record.vue?vue&type=script&lang=js"

import "./Record.vue?vue&type=style&index=0&id=23170551&lang=css"

import exportComponent from "E:\\电梯项目文档\\lcFrontEnd\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__